import type { Job, PushedJob } from "../types/jobs.types";

/**
 * Maps a Job (from the REST index) to a PushedJob (used by the live counter).
 *
 * `deletable` defaults to false because the index endpoint omits it;
 * the real value arrives via Pusher push or modal fetch.
 * `timestamp` marks when the entry was seeded into the counter.
 */
export const mapJobToPushedJob = (job: Job): PushedJob => ({
  uuid: job.uuid,
  processed: job.processed,
  total: job.total,
  percent: job.percent,
  deletable: false,
  resource: job.resource,
  title: job.title,
  status_code: job.status_code,
  status_label: job.status_label,
  representative_name: job.representative_name,
  created_at: job.created_at,
  timestamp: Date.now(),
});
